import Vue from 'vue';
import priceFieldTransformer from './../../transformers/priceField';
import store from './../../store';

const success = ({ data }) => priceFieldTransformer.fetch(data);

const failed = (error, reject) => reject(error);

export default id => (
  new Promise((resolve, reject) => {
    const priceFields = store.state.priceField.items.filter(p => (
      id.toString() === p.id.toString()
    ));

    if (priceFields.length > 0) {
      return resolve(priceFields[0]);
    }

    return Vue.$http.get(`/price_fields/${id}`)
      .then((response) => {
        resolve(success(response));
      })
      .catch((error) => {
        failed(error, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/priceField/show.js